module.exports = "mat-spinner {\r\n    display: inline-block;\r\n    margin-bottom: 30px;\r\n}"